import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProdutosPage = () => {
  useEffect(() => {
    // Update document title
    document.title = 'Produtos Financeiros Campinas - Carbone Soluções';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Conheça todos os produtos financeiros da Carbone em Campinas: empréstimo INSS, crédito CLT, portabilidade, refinanciamento, financiamento de veículos e imóveis, e crédito agrícola. Soluções completas para sua tranquilidade financeira.');
    }

    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://example.com/produtos');
    }

    // Add JSON-LD structured data
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Produtos e Serviços - Carbone Soluções Financeiras",
      "description": "Conheça todos os produtos financeiros da Carbone: empréstimo INSS, crédito CLT, portabilidade, refinanciamento, financiamento de veículos e imóveis, e crédito agrícola.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/produtos`,
      "mainEntity": {
        "@type": "ItemList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Empréstimo INSS",
            "description": "Crédito consignado para aposentados e pensionistas do INSS com as melhores taxas"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Crédito CLT",
            "description": "Empréstimo consignado para trabalhadores CLT com desconto em folha"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Portabilidade",
            "description": "Transfira seu empréstimo para taxas menores e economize"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "Refinanciamento",
            "description": "Renegocie suas dívidas com condições melhores"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "Financiamento de Veículos",
            "description": "Realize o sonho do carro próprio com financiamento facilitado"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "Financiamento de Imóveis",
            "description": "Conquiste sua casa própria com as melhores condições"
          },
          {
            "@type": "ListItem",
            "position": 7,
            "name": "Crédito Agrícola",
            "description": "Financiamento especial para o agronegócio"
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const products = [
    {
      id: 'inss',
      icon: 'ri-user-heart-line',
      title: 'Empréstimo INSS',
      subtitle: 'Para Aposentados e Pensionistas',
      image: 'https://public.readdy.ai/ai/img_res/88b7fa0d7ee9a430324bc4dd6e6f97f2.jpg',
      features: [
        'Até 35% da margem consignável disponível',
        'Taxas a partir de 1,49% ao mês',
        'Desconto direto no benefício do INSS',
        'Sem consulta ao SPC/Serasa',
        'Aprovação em até 24 horas',
        'Dinheiro na conta rapidamente',
        'Atendimento especializado para a terceira idade',
        'Processo 100% seguro e transparente',
      ],
      details: 'O empréstimo consignado INSS é a modalidade de crédito mais vantajosa para aposentados e pensionistas. Com as menores taxas do mercado e desconto automático no benefício, você tem segurança e tranquilidade para realizar seus sonhos.',
      whatsappMessage: 'Olá! Quero saber mais sobre o consignado para aposentados INSS.',
    },
    {
      id: 'clt',
      icon: 'ri-briefcase-line',
      title: 'Crédito CLT',
      subtitle: 'Para Trabalhadores e Servidores',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20worker%20in%20business%20casual%20attire%20smiling%20confidently%20in%20modern%20office%20environment%20with%20navy%20blue%20and%20gold%20accents%20elegant%20corporate%20atmosphere%20successful%20career%20financial%20stability%20realistic%20photography%20high%20quality&width=800&height=600&seq=clt-product-navy&orientation=landscape',
      features: [
        'Desconto direto na folha de pagamento',
        'Taxas reduzidas a partir de 1,69% a.m.',
        'Disponível para CLT e servidores públicos',
        'Sem comprometer seu orçamento',
        'Parcelas fixas e previsíveis',
        'Liberação rápida do crédito',
        'Possibilidade de portabilidade',
        'Atendimento personalizado',
      ],
      details: 'Para trabalhadores com carteira assinada e servidores públicos, o crédito consignado oferece condições especiais com desconto em folha. Ideal para quem busca taxas justas e segurança no pagamento.',
      whatsappMessage: 'Olá! Quero saber mais sobre o Crédito CLT.',
    },
    {
      id: 'portabilidade',
      icon: 'ri-exchange-line',
      title: 'Portabilidade',
      subtitle: 'Reduza Suas Parcelas',
      image: 'https://readdy.ai/api/search-image?query=happy%20brazilian%20person%20looking%20at%20smartphone%20with%20relief%20and%20joy%20in%20bright%20modern%20home%20with%20navy%20blue%20and%20gold%20accents%20elegant%20decor%20natural%20sunlight%20financial%20freedom%20savings%20celebration%20realistic%20photography%20high%20quality&width=800&height=600&seq=portabilidade-product-navy&orientation=landscape',
      features: [
        'Reduza sua parcela em até 40%',
        'Transfira seu empréstimo para a Carbone',
        'Sem custo de transferência',
        'Processo 100% digital',
        'Mantenha o mesmo prazo ou estenda',
        'Análise gratuita do seu contrato atual',
        'Economia garantida',
        'Suporte completo durante a transferência',
      ],
      details: 'Já tem um empréstimo consignado? Faça a portabilidade para a Carbone e pague menos! Analisamos seu contrato atual e oferecemos condições melhores, reduzindo significativamente o valor das suas parcelas.',
      whatsappMessage: 'Olá! Quero saber mais sobre Portabilidade de crédito.',
    },
    {
      id: 'refinanciamento',
      icon: 'ri-money-dollar-circle-line',
      title: 'Refinanciamento',
      subtitle: 'Receba Troco na Conta',
      image: 'https://readdy.ai/api/search-image?query=brazilian%20person%20celebrating%20with%20arms%20raised%20in%20joy%20in%20bright%20modern%20living%20room%20with%20navy%20blue%20and%20gold%20accents%20elegant%20decor%20natural%20sunlight%20financial%20relief%20debt%20free%20happiness%20realistic%20photography%20high%20quality&width=800&height=600&seq=refinanciamento-product-navy&orientation=landscape',
      features: [
        'Receba dinheiro extra na sua conta',
        'Quite dívidas com juros altos',
        'Parcelas menores e mais confortáveis',
        'Use a diferença como quiser',
        'Mantenha o desconto em folha',
        'Processo rápido e descomplicado',
        'Simule sem compromisso',
        'Consultoria financeira gratuita',
      ],
      details: 'Refinancie seu empréstimo consignado atual e receba a diferença em dinheiro! Perfeito para quitar dívidas caras, fazer reformas ou realizar aquele sonho. Você mantém o desconto em folha com parcelas menores.',
      whatsappMessage: 'Olá! Quero saber mais sobre Refinanciamento de crédito.',
    },
    {
      id: 'cartao',
      icon: 'ri-bank-card-line',
      title: 'Cartão Consignado',
      subtitle: 'Limite Garantido',
      image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20holding%20gold%20credit%20card%20with%20shopping%20bags%20in%20background%20modern%20bright%20retail%20environment%20with%20navy%20blue%20and%20gold%20accents%20elegant%20atmosphere%20financial%20convenience%20secure%20payment%20realistic%20photography%20high%20quality&width=800&height=600&seq=cartao-product-navy&orientation=landscape',
      features: [
        'Limite pré-aprovado garantido',
        'Desconto automático no benefício',
        'Sem anuidade',
        'Aceito em todo o Brasil',
        'Compras parceladas sem juros',
        'Controle total pelo app',
        'Segurança e praticidade',
        'Ideal para o dia a dia',
      ],
      details: 'O Cartão Consignado oferece limite garantido com desconto direto no seu benefício ou salário. Sem surpresas, sem anuidade e com total controle dos seus gastos. Perfeito para compras do dia a dia com segurança.',
      whatsappMessage: 'Olá! Quero saber mais sobre Cartão Consignado.',
    },
    {
      id: 'veiculos',
      icon: 'ri-car-line',
      title: 'Financiamento de Veículos',
      subtitle: 'Realize Seu Sonho',
      image: 'https://readdy.ai/api/search-image?query=happy%20brazilian%20family%20receiving%20car%20keys%20at%20dealership%20modern%20showroom%20with%20navy%20blue%20and%20gold%20accents%20elegant%20atmosphere%20new%20car%20purchase%20celebration%20financial%20achievement%20realistic%20photography%20high%20quality&width=800&height=600&seq=veiculos-product-navy&orientation=landscape',
      features: [
        'Taxas competitivas do mercado',
        'Financiamento de novos e seminovos',
        'Aprovação rápida e descomplicada',
        'Parcelas que cabem no bolso',
        'Entrada facilitada',
        'Prazo de até 60 meses',
        'Sem burocracia',
        'Atendimento personalizado',
      ],
      details: 'Realize o sonho do carro próprio com o financiamento de veículos da Carbone. Oferecemos as melhores condições para você adquirir seu veículo novo ou seminovo com parcelas que cabem no seu orçamento.',
      whatsappMessage: 'Olá! Quero saber mais sobre Financiamento de Veículos.',
    },
    {
      id: 'imoveis',
      icon: 'ri-home-4-line',
      title: 'Financiamento de Imóveis',
      subtitle: 'Casa Própria',
      image: 'https://readdy.ai/api/search-image?query=happy%20brazilian%20couple%20holding%20house%20keys%20in%20front%20of%20new%20home%20modern%20architecture%20with%20navy%20blue%20door%20and%20gold%20details%20elegant%20neighborhood%20real%20estate%20purchase%20celebration%20realistic%20photography%20high%20quality&width=800&height=600&seq=imoveis-product-navy&orientation=landscape',
      features: [
        'Prazo de até 35 anos para pagar',
        'Use seu FGTS como entrada',
        'Taxas especiais e competitivas',
        'Financiamento de até 80% do imóvel',
        'Imóveis novos ou usados',
        'Processo simplificado',
        'Assessoria completa',
        'Parceria com principais bancos',
      ],
      details: 'A casa própria está mais perto do que você imagina! Com o financiamento imobiliário da Carbone, você tem acesso às melhores condições do mercado, podendo usar seu FGTS e pagar em até 35 anos.',
      whatsappMessage: 'Olá! Quero saber mais sobre Financiamento de Imóveis.',
    },
    {
      id: 'agricola',
      icon: 'ri-plant-line',
      title: 'Crédito Agrícola',
      subtitle: 'Para o Produtor Rural',
      image: 'https://readdy.ai/api/search-image?query=brazilian%20farmer%20in%20agricultural%20field%20with%20modern%20farming%20equipment%20golden%20wheat%20harvest%20sunset%20lighting%20rural%20prosperity%20agricultural%20success%20navy%20blue%20tractor%20gold%20harvest%20realistic%20photography%20high%20quality&width=800&height=600&seq=agricola-product-navy&orientation=landscape',
      features: [
        'Crédito para custeio e investimento',
        'Carência especial para safra',
        'Taxas subsidiadas pelo governo',
        'Financiamento de máquinas e equipamentos',
        'Capital de giro para produção',
        'Prazo adequado ao ciclo produtivo',
        'Assessoria especializada no agro',
        'Parceria com bancos rurais',
      ],
      details: 'O crédito agrícola da Carbone é a solução completa para o produtor rural. Oferecemos linhas de custeio, investimento e comercialização com taxas subsidiadas e prazos adequados ao ciclo da sua produção.',
      whatsappMessage: 'Olá! Quero saber mais sobre Crédito Agrícola.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-16 bg-gradient-to-br from-navy-50 via-white to-gold-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-5xl lg:text-6xl font-bold text-navy-900 mb-6">
              Nossos Produtos e Serviços
            </h1>
            <p className="text-xl text-navy-600 max-w-3xl mx-auto leading-relaxed">
              Soluções completas de crédito para aposentados, pensionistas, servidores públicos, trabalhadores CLT e produtores rurais. Escolha a opção ideal para você.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white" data-product-shop>
        <div className="max-w-7xl mx-auto px-6">
          <div className="space-y-24">
            {products.map((product, index) => {
              const isEven = index % 2 === 0;

              return (
                <div
                  key={product.id}
                  id={product.id}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    !isEven ? 'lg:flex-row-reverse' : ''
                  }`}
                >
                  <div className={`${!isEven ? 'lg:order-2' : ''}`}>
                    <div className="relative">
                      <div className="absolute -inset-4 bg-gradient-to-r from-navy-200 to-gold-200 opacity-30 blur-2xl rounded-3xl"></div>
                      <div className="relative w-full h-96 flex items-center justify-center">
                        <img
                          src={product.image}
                          alt={product.title}
                          className="w-full h-full object-cover rounded-2xl shadow-2xl"
                        />
                      </div>
                    </div>
                  </div>

                  <div className={`${!isEven ? 'lg:order-1' : ''}`}>
                    <div className="inline-flex items-center gap-2 bg-gold-50 text-gold-700 px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-gold-200">
                      <i className={`${product.icon} text-lg`}></i>
                      {product.subtitle}
                    </div>

                    <h2 className="text-4xl font-bold text-navy-900 mb-4">
                      {product.title}
                    </h2>

                    <p className="text-navy-600 text-lg mb-6 leading-relaxed">
                      {product.details}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
                      {product.features.map((feature, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-gold-500 text-xl mt-0.5"></i>
                          <span className="text-navy-700 text-sm">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4">
                      <a
                        href={`https://wa.me/5519971344445?text=${encodeURIComponent(product.whatsappMessage)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-whatsapp-line text-xl"></i>
                        Falar com um especialista
                      </a>
                      <a
                        href={`https://wa.me/5519971344445?text=${encodeURIComponent(product.whatsappMessage)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="border-2 border-navy-200 hover:border-gold-500 text-navy-700 hover:text-gold-600 font-bold px-8 py-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
                      >
                        Saiba Mais
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 bg-navy-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ainda tem dúvidas sobre qual produto escolher?
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Nossa equipe está pronta para te ajudar a encontrar a melhor solução para suas necessidades
          </p>
          <a
            href="https://wa.me/5519971344445?text=Olá! Preciso de ajuda para escolher o melhor produto."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold text-lg px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-customer-service-2-line text-2xl"></i>
            Falar com Especialista
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProdutosPage;
